import { env } from '../../env';

export const selectCurrentEnv = () => {
  const isDev = env.isDev;

  const envFile = require(isDev ? './configs.dev.json' : './configs.prod.json');
  return JSON.parse(JSON.stringify(envFile));
};
